import { FilterOption } from "../../models/gridFilter";

export function uniqueArrayToFilterOptionHelper(values: string[]): FilterOption[] {
  return values.map((v) => ({
    label: v.charAt(0).toUpperCase() + v.slice(1).replace(/-/g, ' '),
    value: v,
    active: false
  })).sort((a, b) => a.label.localeCompare(b.label));
}
